import { CreateScheduleService } from '@app/shared/services/create-schedule.service';
import { Component, Input, OnInit } from '@angular/core';
import { AirportInfo } from '@app/flight-planning/flight-plan-constant';
import { FlightPlanService } from '@app/flight-planning/route-plan/services/flight-plan.service';

@Component({
    selector: 'app-airports',
    templateUrl: './airports.component.html',
    styleUrls: ['./airports.component.scss'],
    standalone: false
})
export class AirportsComponent implements OnInit {
  public airportInfo = new AirportInfo();
  public airportInfoListing: any;
  public airportdata = 0;
  @Input() public type?: string;
  @Input() public iCAOCode?: string;
  @Input() public iCAOCodeSel?: string;

  public airport: any;
  public airportSel: any;
  constructor(public flightPlanService: FlightPlanService) { }

  public ngOnInit() { }
  public openAccordian() {
    this.flightPlanService.accordionSwitch('airportinfo');
    this.airportdata = 0;
  }
  public ngAfterViewInit() {
    if (this.type == 'airportInfo') {
      const fromCode = (this.iCAOCode || '').trim();
      const toCode = (this.iCAOCodeSel || '').trim();
      if (fromCode) {
        this.flightPlanService.getAirportInfoByIcaoCode(fromCode).then((airport: any) => {
          this.airport = airport;
        });
      }
      if (toCode) {
        this.flightPlanService.getAirportInfoByIcaoCode(toCode).then((airport: any) => {
          this.airportSel = airport;
        });
      }
    } else {
      this.flightPlanService.getAirport().then((data) => {
        this.airportInfoListing = data;
      });
    }
  }
}
